export const BULK_PURCHASE_PRICE_SCOPE = Object.freeze({
    FILL_MISSING: "missing",
    OVERWRITE_ALL: "overwrite",
});

